module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-chevy.bcb1a8d3.png";